export const instagramUrl = 'https://www.instagram.com/bright_digital_hubonline/'
export const checkoutUrl = 'https://complete-crochet-bag-bundle.impultienda.ar/checkout'
export const offerAnchor = '#offer'
export const contactEmail = 'compradigitalyaa@gmail.com'

export const productName = 'Complete Crochet Bag Bundle'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/a6hyfJDsXikKwz9dnEGPsY/Set_completo_de_bolsos_tejidos.png'

export const heroInclusions = [
  'Yarn & Materials',
  'Exact Measurements',
  'Stitch Counts',
  'Row-by-Row Instructions',
  'Assembly',
  'Finishing',
]

export const heroChecklist = [
  '105 Ready-to-Follow Crochet Patterns',
  '5 Complete Volumes + 5 FREE Bonuses',
  '400 Pages Across the Collection',
  'Downloadable PDF Files',
  'Secure Checkout',
  '7-Day Guarantee',
]

export const painQuestions = [
  'How many stitches do you need?',
  'What yarn works best for that design?',
  'How do you shape the base?',
  'How do you make the handles match?',
  'How do you assemble everything neatly?',
]

export const inspirationIdeas = [
  'A trendy crescent bag.',
  'A colorful flower tote.',
  'An elegant raffia handbag.',
  'A cute mini purse.',
  'A spacious beach bag.',
]

export const patternEssentials = [
  'What materials to prepare.',
  "How much yarn you'll need.",
  'Which crochet hook to use.',
  'How many stitches to make.',
  'How to build the body and shape.',
  'How to construct straps, handles, or closures.',
  'How to assemble and finish the project.',
]

export const organizedNeeds = [
  { question: 'Want a modern shoulder bag?', answer: 'Explore a full volume of trendy handbags.' },
  { question: 'Love colorful flowers and granny squares?', answer: 'Find 10 floral bag projects.' },
  {
    question: 'Prefer elegant, boutique-inspired crochet bags?',
    answer: 'Explore raffia and structured designs.',
  },
  {
    question: 'Looking for practical bags you can use every day?',
    answer: 'Discover market bags, beach totes, and spacious everyday styles.',
  },
  {
    question: 'Want something different?',
    answer: 'Create backpacks, sling bags, crossbody purses, and statement handbags.',
  },
  {
    question: 'Love matching accessories?',
    answer: 'Make charms, wallets, mini bags, dimensional flowers, and useful everyday accessories.',
  },
]

export const systemFlow = ['Open Your Bundle', 'Choose a Pattern', 'Follow the Steps', 'Create Your Next Favorite Bag']

export const showcaseFeatures = [
  '50 Complete Crochet Bag Projects',
  '55 Additional Bonus Projects',
  'Trendy Handbags & Shoulder Bags',
  'Floral & Granny Square Designs',
  'Elegant Raffia & Boutique Bags',
  'Beach, Market & Everyday Totes',
  'Functional Bags, Backpacks & Crossbodies',
  'Ready-to-Follow Written Patterns',
  'Yarn Types & Material Quantities',
  'Measurements in Inches & Centimeters',
  'Exact Foundation Chains & Stitch Counts',
  'Row-by-Row & Round-by-Round Instructions',
  'Increases, Decreases & Shaping Details',
  'Handle, Strap & Closure Instructions',
  'Assembly & Finishing Guidance',
  'Practical Diagrams & Construction References',
]

export type Volume = {
  number: string
  name: string
  subtitle: string
  description: string[]
  items: string[]
  details: string
  tagline: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    name: 'Trendy Crochet Handbags',
    subtitle: "10 Modern Handbag Patterns You'll Love Making",
    description: [
      "Create stylish crochet handbags inspired by today's popular shapes and textures.",
      'From compact baguette purses to soft hobo bags and beautiful color-block designs, this volume is filled with fashionable projects.',
    ],
    items: [
      'Crescent Crochet Bag',
      'Baguette Crochet Bag',
      'Mini Bucket Bag',
      'Chunky Yarn Handbag',
      'Hobo Crochet Bag',
      'Bow Detail Shoulder Bag',
      'Minimalist Shoulder Bag',
      'Foldover Crochet Bag',
      'Braided Handle Handbag',
      'Modern Color-Block Bag',
    ],
    details:
      'Each project covers its design-specific construction, measurements, stitch sequences, handles, assembly, and finishing.',
    tagline: "Trendy Shapes. Beautiful Textures. Handbags You'll Be Excited to Create.",
  },
  {
    number: '02',
    name: 'Floral & Granny Square Crochet Bags',
    subtitle: '10 Colorful Floral Bag Patterns',
    description: [
      'Bring flowers, color, and creativity to your handmade collection.',
      'Discover crochet bags with daisies, sunflowers, roses, dimensional flowers, and beautiful granny square combinations.',
    ],
    items: [
      'Daisy Granny Square Tote',
      'Sunflower Crochet Bag',
      '3D Flower Handbag',
      'Classic Granny Square Shoulder Bag',
      'Floral Patchwork Tote',
      'Boho Flower Crossbody',
      'Rose Motif Crochet Bag',
      'Retro Colorful Granny Bag',
      'Flower-Shaped Crochet Bag',
      'Elegant Floral Mini Bag',
    ],
    details:
      'Learn how each design comes together through motif construction, color placement, joining instructions, bag assembly, and finishing details.',
    tagline: 'Beautiful Flowers. Creative Color Combinations. Eye-Catching Handmade Bags.',
  },
  {
    number: '03',
    name: 'Raffia & Boutique Crochet Bags',
    subtitle: '10 Elegant Boutique-Inspired Patterns',
    description: [
      'Love the look of polished handmade handbags?',
      'This volume features sophisticated shapes, raffia textures, decorative handles, structured silhouettes, and carefully designed finishes.',
    ],
    items: [
      'Premium Raffia Tote',
      'Structured Boutique Handbag',
      'Elegant Evening Clutch',
      'Pearl-Style Handle Bag',
      'Round Raffia Handbag',
      'Woven-Texture Crochet Purse',
      'Luxury Mini Handbag',
      'Premium Crossbody Purse',
      'Two-Tone Boutique Bag',
      'Signature Structured Tote',
    ],
    details:
      'Each design includes the relevant measurements, construction sequences, assembly instructions, handles, closures, and finishing methods.',
    tagline: 'Elegant Designs. Boutique-Inspired Details. Beautiful Handmade Style.',
  },
  {
    number: '04',
    name: 'Market, Beach & Everyday Crochet Bags',
    subtitle: '10 Practical Bags for Everyday Life',
    description: [
      'Create spacious, versatile crochet bags for shopping, summer outings, beach days, and daily activities.',
      'From openwork market bags to oversized beach totes, these projects combine functionality with handmade style.',
    ],
    items: [
      'Classic Everyday Tote',
      'Mesh Market Bag',
      'Oversized Beach Tote',
      'Striped Summer Bag',
      'Openwork Crochet Tote',
      'Wide Strap Everyday Bag',
      'Boho Fringe Tote',
      'Reusable Grocery Bag',
      'Two-Tone Casual Tote',
      'Large Family Beach Bag',
    ],
    details:
      'Explore bag bases, stitch patterns, body construction, handle reinforcement, joining methods, and finishing instructions.',
    tagline: 'Spacious Designs. Everyday Functionality. Crochet Bags Made for Real Life.',
  },
  {
    number: '05',
    name: 'Statement & Functional Crochet Bags',
    subtitle: '10 Creative Designs With Practical Features',
    description: [
      'Explore a different side of crochet handbag design.',
      'From adjustable crossbody bags and functional backpacks to playful strawberry and heart-shaped purses, these projects add variety to your collection.',
    ],
    items: [
      'Crochet Drawstring Backpack',
      'Mini Crochet Backpack',
      'Everyday Sling Bag',
      'Adjustable Strap Crossbody',
      'Crochet Belt Bag',
      'Multi-Pocket Crochet Bag',
      'Strawberry-Shaped Crochet Purse',
      'Heart-Shaped Crochet Handbag',
      'Crochet Project Organizer Bag',
      'Large Weekend Crochet Bag',
    ],
    details:
      'Each pattern includes the required construction details, measurements, straps, compartments, closures, assembly, and finishing instructions.',
    tagline: 'Creative Shapes. Practical Details. Unique Crochet Projects.',
  },
]

export const differentiators = [
  {
    icon: 'list',
    title: 'Ready-to-Follow Instructions',
    text: 'Each project is designed to guide you through its construction with materials, measurements, stitch instructions, assembly details, and finishing steps.',
  },
  {
    icon: 'bag',
    title: 'Beautiful Modern Handbags',
    text: 'Explore trendy shoulder bags, baguette purses, boutique-inspired handbags, colorful designs, and stylish statement pieces.',
  },
  {
    icon: 'sun',
    title: 'Practical Everyday Bags',
    text: 'Make beach totes, shopping bags, crossbody purses, backpacks, and other functional accessories.',
  },
  {
    icon: 'flower',
    title: 'Creative Floral Projects',
    text: 'Discover granny square designs, dimensional flowers, botanical decorations, and beautiful handmade details.',
  },
  {
    icon: 'gift',
    title: '55 Additional Accessories',
    text: 'Create wallets, charms, mini bags, pouches, holders, and organizers to complement your handmade collection.',
  },
  {
    icon: 'library',
    title: 'One Organized Digital Bundle',
    text: 'Keep your patterns together in ten downloadable books, ready whenever you want to begin another project.',
  },
] as const

export const finalQuestions = [
  'A trendy crescent bag?',
  'A beautiful sunflower tote?',
  'An elegant raffia handbag?',
  'A spacious beach bag?',
  'A cute mini purse?',
  'Or a whole collection of matching accessories?',
]

export const finalStack = [
  '50 Crochet Bags.',
  '55 Bonus Accessory Projects.',
  '105 Ready-to-Follow Patterns.',
  'One Complete Digital Collection.',
]
